import React from 'react'
import Header7 from '../../Globle/Header7'
import Smallnav from '../Mainhomeseven/Smallnav'
import Banner from '../Mainhomeseven/Banner'
import Deal from '../Mainhomeseven/Deal'
import Testimonal from '../Mainhomeseven/Testimonial'
import About from '../Mainhomeseven/About'
import Faq from '../Mainhomeseven/Faq'
import Subscribe from '../Mainhomeseven/Subscribe'
import Blog from '../Mainhomeseven/Blog'
import Footer7 from '../../Globle/Footer7'

const Main = () => {
    return (
        <>
            <Header7 />
            <Smallnav />
            <Banner />
            <Deal />
            <Testimonal />
            <About />
            <Faq />
            <Subscribe />
            <Blog />
            <Footer7 />
        </>
    )
}

export default Main
